import { createAction } from 'redux-api-middleware'
import type { RootState } from '../../reducers'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import type { Promo } from '../../types'
import ActionTypes from './actionTypes'

type CompletePromoUploadRequest = {
    type: typeof ActionTypes.COMPLETE_PROMO_UPLOAD_REQUEST;
    payload: never;
}

type CompletePromoUploadFailure = {
    type: typeof ActionTypes.COMPLETE_PROMO_UPLOAD_FAILURE;
    payload: Error;
}

type CompletePromoUploadSuccess = {
    type: typeof ActionTypes.COMPLETE_PROMO_UPLOAD_SUCCESS;
    payload: Promo & {
        filename: string;
        upload_id: string;
    };
}

/**
 * Notify that a promo got its asset uploaded
 */
function completePromoUpload(promoId: number) {
    return createAction<RootState, Promo, never>({
        endpoint: `${HUBBLE_API_TOKEN}/promos/${promoId}/upload/completed`,
        method: 'POST',
        types: [
            ActionTypes.COMPLETE_PROMO_UPLOAD_REQUEST,
            ActionTypes.COMPLETE_PROMO_UPLOAD_SUCCESS,
            ActionTypes.COMPLETE_PROMO_UPLOAD_FAILURE,
        ],
    })
}

export type CompletePromoUploadAction = CompletePromoUploadRequest
    | CompletePromoUploadFailure
    | CompletePromoUploadSuccess

export default completePromoUpload
